import axios, { AxiosResponse } from 'axios';
import getEnv from '../../env/enviroment';

interface Params {
  filter?: string;
}

function getAbsUrl(url: string) {
  return `${getEnv().monolith_server || ''}${url}`;
}

export function post<T, R = void>(
  url: string,
  values: T,
  headers = {},
): Promise<AxiosResponse<R>> {
  return axios.post(getAbsUrl(url), values, {
    withCredentials: true,
    headers: {
      'Content-Type': 'application/json;charset=utf-8',
      ...headers,
    },
  });
}

export function get<T>(
  url: string,
  params: Params = {},
  headers = {},
): Promise<AxiosResponse<T>> {
  return axios.get<T>(getAbsUrl(url), {
    params,
    headers,
  });
}
